import XeroSmallIcon from 'assets/images/xero_small.png';
import DearSmallIcon from 'assets/images/dear_small.png';
import ZohoSmallIcon from 'assets/images/zoho_small.png';
import QuickbooksSmallIcon from 'assets/images/quickbooks_small.png';
import ExcelSmallIcon from 'assets/images/excel_small.png';
import ReceiptsSmallIcon from 'assets/images/receipts_small.png';
import { Provider } from 'store/api/enums';

/**
 * Provider logo URLs keyed by canonical API `providerName` (see {@link Provider}).
 * Add a new asset here when introducing a provider that should show a brand mark in tables.
 */
export const PROVIDER_ICON_SRC: Record<string, string> = {
  [Provider.XERO]: XeroSmallIcon,
  [Provider.CIN7]: DearSmallIcon,
  [Provider.ZOHO]: ZohoSmallIcon,
  [Provider.QUICKBOOKS]: QuickbooksSmallIcon,
  [Provider.EXCEL]: ExcelSmallIcon,
  [Provider.RECEIPTS]: ReceiptsSmallIcon,
};

/**
 * Resolves the small provider logo URL for arbitrary `providerName` strings from the API,
 * including common variants (e.g. "QuickBooks Online", "Zoho Books", "Provider Receipt").
 */
export function resolveProviderIconSrc(
  providerName: string | undefined | null
): string | undefined {
  if (!providerName?.trim()) return undefined;
  const n = providerName.toLowerCase().trim();
  if (PROVIDER_ICON_SRC[n]) return PROVIDER_ICON_SRC[n];
  if (n.includes('quickbook')) return PROVIDER_ICON_SRC[Provider.QUICKBOOKS];
  if (n.includes('zoho')) return PROVIDER_ICON_SRC[Provider.ZOHO];
  if (n.includes('xero')) return PROVIDER_ICON_SRC[Provider.XERO];
  if (n.includes('dear') || n.includes('cin7'))
    return PROVIDER_ICON_SRC[Provider.CIN7];
  if (n.includes('receipt')) return PROVIDER_ICON_SRC[Provider.RECEIPTS];
  if (n.includes('excel')) return PROVIDER_ICON_SRC[Provider.EXCEL];
  const head = n.split(/[\s_/-]+/)[0];
  if (head && PROVIDER_ICON_SRC[head]) return PROVIDER_ICON_SRC[head];
  return undefined;
}
